import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classnames from 'classnames';
import TextButton from '../elements-buttons/text-button';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class SeeCurrentDetails extends Component {
  render () {
    const {
      className,
      iosWebView,
      toggleModal
    } = this.props;

    return (
      <div className={classnames('SeeCurrentDetails', className)}>
        {
          iosWebView ?
            <div>
              <TextButton
                id="see-current-details-button"
                buttonText={ this.props.intl.formatMessage({ id: 'inbox.see_current_details.see_button', defaultMessage: 'See the current details' }) }
                icon={<div className="custom-arrow right" />}
                iconPosition="right"
                onClick={() => { toggleModal('CurrentDetailsContainerModal'); }}
              />
            </div>
            :
            <Link to={`current-details`} target="_blank">
              <FormattedMessage
                id="inbox.see_current_details.current_details"
                defaultMessage="See the current details"
              />
              <div className="custom-arrow right" />
            </Link>
        }
      </div>
    );
  }
}

SeeCurrentDetails.propTypes = {
  className: PropTypes.string,
  iosWebView: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(SeeCurrentDetails);
